import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const namespace = 'features';
export const keyPrefix = 'attach_face_to_card';
export const useAttachFaceToCardTranslation = (): UseTranslationResponse<
  typeof namespace,
  typeof keyPrefix
> => useTranslation(namespace, { keyPrefix });

export const ru = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Добавить лицо в карточку',
    toast_error: 'Не удалось добавить лицо в карточку',
    toast_success: 'Лицо добавлено в карточку',
    placeholder: 'ID карточки или ФИО',
    button_add: 'Добавить',
    button_details: 'Детали лица',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Add face to card',
    toast_error: 'Failed to add face to card',
    toast_success: 'Face is added to the card',
    placeholder: 'Card ID or full name',
    button_add: 'Add',
    button_details: 'Face details',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Adicionar rosto ao cartão',
    toast_error: 'Não foi possível adicionar o rosto ao cartão',
    toast_success: 'Rosto adicionado ao cartão',
    placeholder: 'ID do cartão ou nome completo',
    button_add: 'Adicionar',
    button_details: 'Detalhes do rosto',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Añadir rostro a la tarjeta',
    toast_error: 'No se pudo añadir el rostro a la tarjeta',
    toast_success: 'Rostro añadido a la tarjeta',
    placeholder: 'ID de la tarjeta o nombre completo',
    button_add: 'Añadir',
    button_details: 'Detalles del rostro',
  },
}) : {}) as Record<string, unknown>;
